import {Directive, ElementRef, Host, Optional} from '@angular/core';
import {UiButtonComponent} from '../../ui-button/ui-button.component';
import {UiHighlightComponent} from '../../ui-highlight/ui-highlight.component';

@Directive({
    selector: '[drop-trigger]',
    standalone: false
})
export class DropTriggerDirective {
    constructor(
        public el: ElementRef,
        @Optional() @Host() public button?: UiButtonComponent,
        @Optional() @Host() public highlight?: UiHighlightComponent) {}
}
